/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalecomplexemotionsweak4Inputs */



/**
* | output |
* | --- |
* | "Making sense of mixed or ambiguous emotions can be hard for you — looking into what causes them will help you understand your own state better." |
*
* @param {Eisubscalecomplexemotionsweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalecomplexemotionsweak4 = /** @type {((inputs?: Eisubscalecomplexemotionsweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalecomplexemotionsweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Making sense of mixed or ambiguous emotions can be hard for you — looking into what causes them will help you understand your own state better.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta aclararte con las emociones mezcladas o ambiguas — observar sus causas te ayudará a entender mejor tu estado.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно разобраться в смешанных или неоднозначных эмоциях — наблюдение за их причинами поможет лучше понимать своё состояние.")
});
export { eisubscalecomplexemotionsweak4 as "eiSubscaleComplexEmotionsWeak" }